"use client";
import React from 'react';
import { 
  Dialog, DialogTitle, DialogContent, DialogActions, 
  Button, Typography, Box, Divider, Chip, CircularProgress 
} from '@mui/material';
import { WarningAmberOutlined as WarningIcon, People as PeopleIcon } from '@mui/icons-material';

const GroupConfirmModal = ({ open, onClose, onConfirm, targetType, targetCount, message, isLoading }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#F59E0B', pb: 1 }}>
        <WarningIcon />
        <Typography variant="h6" fontWeight={800}>Confirm Broadcast</Typography>
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          You are about to send a mass message to:
        </Typography>
        
        <Box sx={{ bgcolor: '#F3F4F6', p: 2, borderRadius: '12px', my: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography variant="caption" fontWeight={700}>Target:</Typography>
            <Chip 
              icon={<PeopleIcon sx={{ fontSize: '14px !important' }} />} 
              label={targetType === 'all' ? "All Employees" : `${targetCount} Selected`} 
              size="small" 
              sx={{ fontWeight: 700, bgcolor: '#fff', border: '1px solid #E5E7EB' }} 
            />
          </Box>
          <Divider sx={{ my: 1 }} />
          <Typography variant="caption" fontWeight={700} display="block" gutterBottom>Message Preview:</Typography>
          <Typography variant="body2" sx={{ fontStyle: 'italic', color: '#4B5563', wordBreak: 'break-word' }}>
            "{message}"
          </Typography>
        </Box>
        
        <Typography sx={{ fontSize: '11px', color: '#EF4444', fontWeight: 600, textAlign: 'center', display: 'block' }}>
          * This action will send individual emails to all selected recipients.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button 
          onClick={onClose} 
          disabled={isLoading} 
          sx={{ color: '#6B7280', fontWeight: 700, textTransform: 'none' }}
        >
          Cancel
        </Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
          sx={{ 
            bgcolor: '#007FFF', 
            borderRadius: '8px', 
            px: 3, 
            fontWeight: 700, 
            textTransform: 'none', 
            '&:hover': { bgcolor: '#0066CC' },
            minWidth: '130px' 
          }}
        >
          {isLoading ? 'Sending...' : 'Confirm & Send'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GroupConfirmModal;